export enum SubscriptionStatus {
    ACTIVE = 0,
    ONHOLD = 1,
    LASTBILLING = 2,
    TERMINATED = 3,
    ARCHIVED = 4
}
